export default __webpack_public_path__ + "static/media/section2_pic3.82f84cba.webp";